import { render, staticRenderFns } from "./AccountSettingsNotifications.vue?vue&type=template&id=20fcbab1&scoped=true&"
import script from "./AccountSettingsNotifications.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingsNotifications.vue?vue&type=style&index=0&id=20fcbab1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fcbab1",
  null
  
)

/* custom blocks */
import block0 from "./AccountSettingsNotifications.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./AccountSettingsNotifications.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VSwitch})
